// extracted by mini-css-extract-plugin
export default {"button":"DeleteExclusionRowButtons_button__DNQD8"};